<div id="htmlData" class="container-fluid py-3">
  <ng-container *ngIf="simulationTab.status <= 0">
    <div class="row mt-3">
      <div class="col">
        <label for="name">Click on map to change location</label>
        <div class="map" leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)" (leafletClick)="mapClicked($event)">
          <div *ngIf="simulationTab" [leafletLayer]="marker"></div>
        </div>
      </div>

      <div class="col">
        <form [formGroup]="simulationForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="name">Name</label>
            <input type="text" class="form-control" id="name" formControlName="name">
          </div>
          <div *ngIf="simulationForm.controls['name'].invalid && (simulationForm.controls['name'].dirty || simulationForm.controls['name'].touched || simulationFormSubmmited)" class="alert alert-danger alert-mini">
            <div *ngIf="simulationForm.controls['name'].errors.required">
              Name is required.
            </div>
          </div>

          <div class="form-group">
            <label for="coordinates">Latitude, longitude</label>
            <input type="text" class="form-control" id="coordinates" formControlName="coordinates">
          </div>
          <div *ngIf="simulationForm.controls['coordinates'].invalid && (simulationForm.controls['coordinates'].dirty || simulationForm.controls['coordinates'].touched || simulationFormSubmmited)" class="alert alert-danger alert-mini">
            <div *ngIf="simulationForm.controls['coordinates'].errors.required">
              Coordinates are required.
            </div>
            <div *ngIf="simulationForm.controls['coordinates'].errors.pattern">
              Coordinates must be valid (lat, lon).
            </div>
          </div>

          <div class="form-group">
            <label for="crop">Crop</label>
            <select class="form-control" id="crop" formControlName="crop" (change)="onCropChange($event.target.value)">
              <option [value]="null" disabled selected>Select a crop</option>
              <option *ngFor="let crop of crops" [value]="crop.id">{{crop.name}}</option>
            </select>
          </div>
          <div *ngIf="simulationForm.controls['crop'].invalid && (simulationForm.controls['crop'].dirty || simulationForm.controls['crop'].touched || simulationFormSubmmited)" class="alert alert-danger alert-mini">
            <div *ngIf="simulationForm.controls['crop'].errors.required">
              Crop is required.
            </div>
          </div>

          <div class="form-group">
            <label for="maturity">Variety/MG/CRM</label>
            <select class="form-control" id="maturity" formControlName="maturity">
              <option [value]="null" disabled selected>
                <ng-container *ngIf="selectedCrop == null">Select a crop first</ng-container>
                <ng-container *ngIf="selectedCrop != null">Select a variety</ng-container>
              </option>
              <ng-container *ngIf="selectedCrop != null">
                <option *ngFor="let variety of selectedCrop.varieties" [value]="variety.id">{{variety.name}}</option>
              </ng-container>
            </select>
          </div>
          <div *ngIf="simulationForm.controls['maturity'].invalid && (simulationForm.controls['maturity'].dirty || simulationForm.controls['maturity'].touched || simulationFormSubmmited)" class="alert alert-danger alert-mini">
            <div *ngIf="simulationForm.controls['maturity'].errors.required">
              Variety/MG/CRM is required.
            </div>
          </div>

          <div class="form-group">
            <label for="plantingDate">Planting date</label>
            <input type="text" autocomplete="off" id="plantingDate" placeholder="Planting date" class="form-control" formControlName="plantingDate" bsDatepicker [bsConfig]="bsConfig">
          </div>
          <div *ngIf="simulationForm.controls['plantingDate'].invalid && (simulationFormSubmmited)" class="alert alert-danger alert-mini">
            <div *ngIf="simulationForm.controls['plantingDate'].errors">
              Planting date is required and must be valid (mm/dd/yyyy).
            </div>
          </div>

          <div class="text-right pt-3">
            <button type="button" class="btn btn-secondary mr-2" *ngIf="this.simulationTab.status == -1" (click)="this.simulationTab.status=3">
              Cancel
            </button>
            <button type="submit" class="btn btn-primary">
              Run simulation
            </button>
          </div>
        </form>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="simulationTab.status >= 1">
    <div class="row">
      <div class="col">
        <h4 class="mb-0">{{simulationTab.name}}</h4>
      </div>

      <div class="col text-right pb-3">
        <button type="button" class="btn btn-sm btn-secondary mr-3" (click)="this.simulationTab.status = -1" [disabled]="simulationTab.status <= 2" data-html2canvas-ignore="true">
          <div class="d-flex">
            <mat-icon svgIcon="pencil"></mat-icon>
            <span class="ml-2">EDIT</span>
          </div>
        </button>
        <button type="button" class="btn btn-sm btn-success" (click)="exportAsPDF('htmlData')" [disabled]="simulationTab.status <= 2 || exporting" data-html2canvas-ignore="true">
          <div class="d-flex" *ngIf="!exporting">
            <mat-icon svgIcon="file-download-outline"></mat-icon>
            <span class="ml-2">PDF</span>
          </div>
          <div class="d-flex" *ngIf="exporting">
            <mat-icon class="mat-icon-preloader" svgIcon="loading"></mat-icon>
          </div>
        </button>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-2">
        <img class="map-small" src="https://api.tiles.mapbox.com/v4/mapbox.satellite/pin-l+00F({{simulationTab.coordinates.longitude}},{{simulationTab.coordinates.latitude}})/{{simulationTab.coordinates.longitude}},{{simulationTab.coordinates.latitude}},13/256x256.png?access_token=pk.eyJ1IjoiYWdyb2NsaW1hdGUiLCJhIjoiY2tqb3FnZDNuNWw3NzJ5cDlnaTA2bWgzOCJ9.uu5G6Z2A7dvZuH34FKnNBg">
      </div>
      <div class="col d-flex justify-content-around align-items-center">
        <div class="text-center pr-2">
          <h4 class="mb-1">{{simulationTab.coordinates.latitude | number: '1.0-4'}}, {{simulationTab.coordinates.longitude | number: '1.0-4'}}</h4>
          <h5 class="sub-label">Location</h5>
        </div>

        <div class="text-center px-2">
          <h4 class="mb-1">{{pDate}}</h4>
          <h5 class="sub-label">Planting date</h5>
        </div>

        <div class="text-center px-2">
          <h4 class="mb-1">{{crop.name}}</h4>
          <h5 class="sub-label">Crop</h5>
        </div>

        <div class="text-center pl-2">
          <h4 class="mb-1">{{maturity.name}}</h4>
          <h5 class="sub-label">Variety/MG/CRM</h5>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="row mt-5 mb-0" *ngIf="simulationTab.status == 1">
    <div class="col">
      <div class="d-flex justify-content-center align-items-center">
        <div class="alert alert-primary" role="alert">
          <h6 class="mb-0">
            Running simulation... {{simulationTab.progressLoad}}%
          </h6>
        </div>
      </div>
    </div>
  </div>

  <div class="row mt-5 mb-0" *ngIf="simulationTab.status == -2">
    <div class="col">
      <div class="d-flex justify-content-center align-items-center">
        <div class="alert alert-danger" role="alert">
          <h6 class="mb-0">
            {{simulationTab.error.message}}. ({{simulationTab.error.code}}). Please change input parameters and try again.
          </h6>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="simulationTab.status >= 2">
    <div class="row mt-5">
      <div class="col">
        <app-simulation-results [(simulation)]="simulationTab"></app-simulation-results>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col text-left">
        <img style="width:80px;" src="assets/nass_logo.jpg">
      </div>
      <div class="col text-right">
        <img style="width:120px;" class="ml-3" src="assets/AgroClimate_150_logo.png">
      </div>
    </div>
  </ng-container>

</div>
